import { DEFAULT_TIMEZONE } from '@performance-crm/shared';
import { useCatalogs } from './queries';
import { useCompanyScope } from './useCompanyScope';

/**
 * Zona horaria de la empresa (`settings.timezone`, en los catálogos): la usan los valores por defecto de fecha,
 * los topes `max` de los campos y los accesos rápidos de Mi día. Sin empresa (o mientras carga), la de Lima.
 */
export function useCompanyTimezone(companyId?: string | null): string {
  const { active } = useCompanyScope();
  const { data } = useCatalogs(companyId ?? active ?? undefined);
  return data?.settings.timezone ?? DEFAULT_TIMEZONE;
}
